import React, { lazy, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Navigate } from "react-router-dom";

import AppRoute from "./route";
import Layout from "../container/layout";
import viewStudent from "../pages/viewStudent";
import Testing from "../pages/testing";
import AttendanceReport from "../pages/attendanceReport";

// import DashboardReport from "../pages/dashboardReport";
// import FeedbackTable from "../container/viewCandidatesTable/feedBackTable";

// ---------- Routes ---------- //
const Login = lazy(() => import("../pages/login"));

const Logout = lazy(() => import("../pages/logout"));

const ViewOrders = lazy(() => import("../pages/viewOrders"));

const BorExams = lazy(() => import("../pages/borExams"));
const Waitlist = lazy(() => import("../pages/waitlist"));


const Dashboard = lazy(() => import("../pages/dashBoard"));

const ViewStudent = lazy(() => import("../pages/viewStudent"));

const FormDetails = lazy(() => import("../pages/formDetails"));

const UserDetails = lazy(() => import("../pages/userDetails"));

const ViewCandidates = lazy(() => import("../pages/viewCandidates"));

const DashboardReport = lazy(() => import("../pages/dashboardReport"));

const Feedback = lazy(() => import("../pages/feedBack"));

const AdmitCard = lazy(() => import("../pages/admitCard"));

const PrintCertificate = lazy(() => import("../pages/printCertificate"));

const viewCertificate = lazy(() => import("../pages/viewCertificate"));

const Subject = lazy(() => import("../pages/question"));

const Topic = lazy(() => import("../pages/question/topic"));

const Question = lazy(() => import("../pages/question/question"));

const LegacyCandidates = lazy(() => import("../pages/legacyCandidates"));

const SpecialSlots = lazy(() => import("../pages/specialSlots"));

const ExamSchedule = lazy(() => import("../pages/examSchedule"));

const PaymentVerify = lazy(() => import("../pages/paymentVerify"));

const SpecialSlotDetail = lazy(() => import("../pages/specialSlotDetail"));

const Users = lazy(() => import("../pages/viewUsers"));

const Cadre = lazy(() => import("../pages/viewCadre"));

const SubjectDetails = lazy(() => import("../pages/subjectDetails"));


const ChangePassword = lazy(() => import("../pages/changePassword"))

// "/login" is mapped as well as "/". Only "/" existed, so a bookmark, a typed
// URL or anything redirecting to /login rendered a blank page with no error —
// no route matched, so nothing was mounted at all.
const openRoutes = [
  { path: "/", exact: true, component: Login },
  { path: "/login", exact: true, component: Login },
];
// $2b$10$SnrbmiberHTAioz.edRkluDYmJtKS5j7EoWw80zbzJK0p6QCxO5A2	

const authRoutes = [
  { path: "/", exact: true, component: ViewStudent, section: "CANDIDATES" },
  {
    path: "/view-students",
    exact: true,
    component: ViewStudent,
    section: "CANDIDATES",
  },
  {
    path: "/view-exams",
    exact: true,
    component: ViewOrders,
    section: "ALL EXAMS",
  },
  {
    path: "/bor-migrated",
    exact: true,
    component: BorExams,
    section: "BOR MIGRATED",
  },
  {
    path: "/waitlist",
    exact: true,
    component: Waitlist,
    section: "BOR MIGRATED",
  },
  {
    path: "/form-details/:id",
    exact: true,
    component: FormDetails,
    section: "",
  },
  {
    // Plain single-segment pattern. An optional trailing param
    // ("/user-details/:id/:ignored?") matched in isolation but rendered nothing
    // inside <Routes> on the production build, which is what left this screen
    // blank while every other route worked.
    path: "/user-details/:id",
    exact: true,
    component: UserDetails,
    section: "",
  },
  {
    path: "/view-candidates/:id",
    exact: true,
    component: ViewCandidates,
    section: "",
  },
  {
    path: "/view-cadre/",
    exact: true,
    component: Cadre,
    section: "",
  },
  {
    path: "/subject-details/:id",
    exact: true,
    component: SubjectDetails,
    section: "",
  },
  {
    path: "/view-candidate/:id",
    exact: true,
    component: LegacyCandidates,
    section: "",
  },
  {
    path: "/view-slots/:id",
    exact: true,
    component: SpecialSlotDetail,
    section: "",
  },
  { path: "/feedback/:id", exact: true, component: Feedback, section: "" },
  { path: "/testing", exact: true, component: Testing, section: "" },
  { path: "/logout", exact: true, component: Logout, section: "" },
  {
    path: "/dashboard",
    exact: true,
    component: DashboardReport,
    section: "DASHBOARD",
  },
  { path: "/report", exact: true, component: Dashboard, section: "REPORT" },

  { path: "/report/pdf", exact: true, component: AttendanceReport, section: "REPORT" },
  {
    path: "/certificates",
    exact: true,
    component: viewCertificate,
    section: "",
  },
  { path: "/subject", exact: true, component: Subject, section: "SUBJECT" },
  { path: "/topic/:id", exact: true, component: Topic, section: "" },
  { path: "/question/:id", exact: true, component: Question, section: "" },
  {
    path: "/special-slots",
    exact: true,
    component: SpecialSlots,
    section: "SPECIAL SLOTS",
  },
  {
    path: "/verify-payment",
    exact: true,
    component: PaymentVerify,
    section: "VERIFY PAYMENT",
  },
  {
    path: "/exam-schedule",
    exact: true,
    component: ExamSchedule,
    section: "EXAM SCHEDULE",
  },
  { path: "/view-users", exact: true, component: Users, section: "NEW USERS" },
  { path: "/change-password", exact: true, component: ChangePassword, section: "CHANGE PASSWORD" },

];
const admitcard = [
  { path: "/admitcard/:user_id/:exam_id", exact: true, component: AdmitCard },
  // Two concrete patterns rather than one optional parameter. A trailing "?"
  // param resolves in isolation but renders nothing inside <Routes> in the
  // production build — the same fault that left /user-details blank — so both
  // shapes are declared explicitly. The certificate number is still honoured
  // when present, since a promoted officer holds more than one certificate and
  // the page would otherwise print whichever came back first.
  {
    path: "/print-certificate/:user_id/:certificate_number",
    exact: true,
    component: PrintCertificate,
  },
  {
    path: "/print-certificate/:user_id",
    exact: true,
    component: PrintCertificate,
  },
];
// routes for attendance
const attendance = [
  { path: "/", exact: true, component: ViewOrders },
  { path: "/view-exams", exact: true, component: ViewOrders },
  { path: "/logout", exact: true, component: Logout },
  { path: "/view-candidates/:id", exact: true, component: ViewCandidates },
];
const PagesRoute = (props) => {
  const [allRoutes, setAllRoutes] = useState([]);
  // props?.auth?.authDetails?.assignedSections
  useEffect(() => {
    if (props.auth.authDetails?.token) {
      if (props?.auth?.authDetails?.data?.user_type === "ATTENDANCE") {
        setAllRoutes([...attendance]);
      } else {
        // check permission before setting
        const filteredRoutes = authRoutes.filter((route) => {
          const sectionName = route.section;
          let hasPermission = sectionName === "" ||
            props?.auth?.authDetails?.assignedSections?.some(
              (permission) => permission.section_name === sectionName
            )
          return hasPermission

        });

        // Add the Logout route to the filtered routes
        filteredRoutes.push({
          path: "/logout",
          exact: true,
          component: Logout,
          section: "",
        });
        // A signed-in user landing on /login — a stale bookmark, the browser
        // restoring a tab — matched no authenticated route and got the same
        // blank page. Send them to the app instead of nowhere.
        filteredRoutes.push({
          path: "/login",
          exact: true,
          component: () => <Navigate to="/report" replace />,
          section: "",
        });
        setAllRoutes([...filteredRoutes]);
      }
      // setAllRoutes([...authRoutes]);
    } else {
      setAllRoutes([...openRoutes]);
    }
  }, [props.auth.authDetails]);
  return (
    <>
      {props.auth.authDetails?.token ? (
        <>
          {window.location.pathname?.includes("admitcard") ||
            window.location.pathname?.includes("print-certificate") ? (
            <>
              {admitcard.map((route, idx) => (
                <AppRoute
                  path={route.path}
                  component={route.component}
                  key={idx}
                  isAuthProtected={true}
                />
              ))}
            </>
          ) : (
            <Layout type={"admin"}>
              {allRoutes.map((route, idx) => (
                <AppRoute
                  path={route.path}
                  component={route.component}
                  key={idx}
                  isAuthProtected={true}
                />
              ))}
            </Layout>
          )}
        </>
      ) : (
        <>
          {openRoutes.map((route, idx) => (
            <AppRoute
              path={route.path}
              component={route.component}
              key={idx}
              isAuthProtected={true}
            />
          ))}
        </>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    auth: state.Auth,
  };
};

export default connect(mapStateToProps, null)(PagesRoute);
